import { MyCanoncpsapComponent } from "./MyCanoncpsapComponent";

export function MyCanoncpsapScreen() {
  return (
    <>
      <MyCanoncpsapComponent />
    </>
  );
}
